export default __webpack_public_path__ + "static/media/img-stake-private-placement.39b11930.png";